import { Field } from "formik";
import React from "react";
import Form from "react-bootstrap/Form";
import { decisionOptions } from "../../utils/commanFiles";

const EnquiryEight = ({ setFieldValue, errors, touched, values }) => {
  return (
    <>
      <div className="account-created-pop">
        <h3>Tell us a little more</h3>

        <div>
          <label>How likely are you to make a decision?</label>
          <div className="radio-select-set">
            {decisionOptions.map((option) => (
              <label key={option.value} style={{ cursor: "pointer" }}>
                <Field
                  type="radio"
                  name="decisionType"
                  value={option.value}
                  style={{ cursor: "pointer" }}
                />
                {option.label}
              </label>
            ))}
          </div>
          {touched.decisionType && errors.decisionType && (
            <div className="error-message">{errors.decisionType}</div>
          )}
        </div>
      </div>
    </>
  );
};

export default EnquiryEight;
